import React, { Fragment } from 'react'

export function getInrFormat(stringNumber) {
	if (!stringNumber) return stringNumber

	// stringNumber is the input string
	var rgx = /(\d+)(\d{3})/
	var z = 0
	var len = String(stringNumber).length
	var num = parseInt(len / 2 - 1)

	while (rgx.test(stringNumber)) {
		if (z > 0) {
			stringNumber = ('' + stringNumber).replace(rgx, '$1' + ',' + '$2')
		} else {
			stringNumber = ('' + stringNumber).replace(rgx, '$1' + ',' + '$2')
			rgx = /(\d+)(\d{2})/
		}
		z++
		num--
		if (num == 0) {
			break
		}
	}
	return stringNumber
}

/**
 * To format the cost amount
 * @param {cost, prefix} param0
 */
export default function CostFormat({
	cost,
	prefix,
	enablePrefix,
	ignoreComma = false,
}) {
	let prefixValue = prefix || '₹'

	if (!cost || (typeof cost !== 'number' && typeof cost !== 'string')) {
		if (enablePrefix) {
			return (
				<Fragment>
					<>{prefixValue}</> 0
				</Fragment>
			)
		}
	}

	// removing all commas if cost is string
	cost =
		typeof cost === 'number'
			? cost
			: cost && cost.replace(new RegExp(',', 'g'), '')

	// handling case wherein cost can become empty string after replacing ','
	cost = cost ? cost : 0

	// making all cost to number
	let floatNo = parseFloat(cost)

	// round-off cost if its a float value
	floatNo = Math.ceil(floatNo)

	let formattedCost = ignoreComma
		? floatNo.toString()
		: getInrFormat(floatNo.toString())
	if (enablePrefix) {
		formattedCost = (
			<>
				{prefixValue} {formattedCost}
			</>
		)
	}

	return <Fragment>{formattedCost}</Fragment>
}
